import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'components/Dialogs/TEDialog';
import ProjectInvoice from 'src/store/models/ProjectInvoice';
import DateInput from 'src/components/Pickers/DateInput';
import { dialog } from 'src/boot/mixins.js';
import utils from 'src/mixins/utils';
import moment from 'moment';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  mixins: [dialog, utils],
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    TeDialog: TeDialog,
    DateInput: DateInput,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  data: function data() {
    return {
      loading: true,
      localInvoices: [],
      pagination: {
        page: 1,
        rowsPerPage: 0,
        sortBy: 'date',
        descending: false
      },
      newInvoice: {
        date: moment().format('YYYY-MM-DD'),
        amount: null,
        originalValue: null,
        editing: true
      },
      columns: [{
        name: 'date',
        label: this.$t('general.date'),
        align: 'left',
        field: 'date',
        headerStyle: 'width: 80px',
        style: 'max-width: 80px',
        sortable: true
      }, {
        name: 'amount',
        label: this.$t('general.amount'),
        align: 'left',
        field: 'amount',
        headerStyle: 'width: 80px',
        style: 'max-width: 80px',
        sortable: true
      }, {
        name: 'actions',
        label: '',
        align: 'left',
        field: 'actions',
        headerStyle: 'width: 60px',
        style: 'max-width: 60px',
        sortable: false
      }]
    };
  },
  computed: {
    totalBilled: function totalBilled() {
      return this.localInvoices.reduce(function (acc, invoice) {
        if (!invoice.editing && invoice.amount) {
          return acc + parseFloat(invoice.amount);
        }

        if (invoice.editing && invoice.project_invoice_id) {
          return acc + parseFloat(invoice.originalValue);
        }

        return acc;
      }, 0);
    },
    billedRatio: function billedRatio() {
      return this.totalBilled / this.project.fixed_fee;
    },
    unbilledAmount: function unbilledAmount() {
      return Math.max(this.project.fixed_fee - this.totalBilled, 0);
    }
  },
  methods: {
    loadData: function loadData(props) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                ProjectInvoice.api().fetch({
                  project_id: _this.project.project_id
                }).then(function (result) {
                  _this.localInvoices = _this.initLocalInvoices(result.response.data);
                  _this.loading = false;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sortMethod: function sortMethod(rows, sortBy, descending) {
      return rows.sort(function (a, b) {
        if (!a.project_invoice_id) {
          return -1;
        }

        if (!b.project_invoice_id) {
          return 1;
        }

        var sortA = a[sortBy];
        var sortB = b[sortBy];

        if (sortBy === 'date') {
          sortA = moment(sortA);
          sortB = moment(sortB);
        }

        if (sortA < sortB) {
          return descending ? 1 : -1;
        }

        if (sortA > sortB) {
          return descending ? -1 : 1;
        }

        return 0;
      });
    },
    isValidInvoice: function isValidInvoice(invoice) {
      return invoice.date && invoice.amount && parseFloat(invoice.amount) > 0 && parseFloat(invoice.amount) <= this.unbilledAmount;
    },
    initLocalInvoices: function initLocalInvoices(invoices) {
      invoices = invoices.map(function (invoice) {
        return _objectSpread(_objectSpread({}, invoice), {}, {
          amount: parseFloat(invoice.amount),
          originalValue: parseFloat(invoice.amount),
          editing: false
        });
      });

      if (this.me.account.hasFeatureAccess('fixed_fee_projects')) {
        invoices.unshift(_objectSpread({}, this.newInvoice));
      }

      return invoices;
    },
    updateInvoice: function updateInvoice(invoice) {
      var _this2 = this;

      this.loading = true;
      ProjectInvoice.api().update(invoice.project_invoice_id, {
        date: invoice.date,
        amount: invoice.amount
      }).then(function () {
        _this2.$q.notify({
          message: _this2.$t('components.projectsInvoiceDialog.amount_updated'),
          color: 'positive'
        });

        invoice.editing = false;

        _this2.loadData();

        _this2.$root.$emit('project-invoices-updated');
      }).catch(function () {
        _this2.loading = false;
      });
    },
    createInvoice: function createInvoice(invoice) {
      var _this3 = this;

      this.loading = true;
      ProjectInvoice.api().store({
        project_id: this.project.project_id,
        date: invoice.date,
        amount: invoice.amount
      }).then(function () {
        _this3.$q.notify({
          message: _this3.$t('components.projectsInvoiceDialog.amount_updated'),
          color: 'positive'
        });

        _this3.localInvoices.shift();

        _this3.loadData();

        _this3.$root.$emit('project-invoices-updated');
      }).catch(function () {
        _this3.loading = false;
      });
    },
    deleteInvoice: function deleteInvoice(invoice) {
      var _this4 = this;

      this.loading = true;
      ProjectInvoice.api().destroy(invoice.project_invoice_id).then(function () {
        _this4.$q.notify({
          message: _this4.$t('components.projectsInvoiceDialog.amount_updated'),
          color: 'positive'
        });

        _this4.loadData();

        _this4.$root.$emit('project-invoices-updated');
      }).catch(function () {
        _this4.loading = false;
      });
    },
    undoEdit: function undoEdit(invoice) {
      invoice.editing = false;
      invoice.amount = invoice.originalValue;
    },
    show: function show() {
      this.$refs.dialog.show();
    },
    hide: function hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide: function onDialogHide() {
      this.$emit('hide');
    },
    onOKClick: function onOKClick() {
      this.$emit('ok');
      this.hide();
    },
    onCancelClick: function onCancelClick() {
      this.hide();
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};